import Swiper, { Autoplay } from 'swiper';

export default (element, data) => {
  const { rotationNumber } = data;
  const rotationNumberConverted = rotationNumber * 1000;
  let slider = null;

  const initSlider = () => {
    if (element.querySelector('[data-promo-slider]')) {
      slider = new Swiper(element.querySelector('[data-promo-slider]'), {
        modules: [Autoplay],
        slidesPerView: 1,
        loop: true,
        mousewheel: true,
        autoplay: {
          delay: rotationNumberConverted,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
      });
    }
    return slider;
  };

  initSlider();
};
